<navaar-container-scroll
  [showHeader]="true"
  [title]="'ارسال تیکت پشتیبانی'"
  [show]="true"
  [isPlayAnimation]="false"
  [showIcon]="true"
  [isFixedContainer]="true"
  [back-url]="['/feedback']"
>
  <section class="feedback-section">
    <form
      autocomplete="off"
      class="form-container"
      [formGroup]="feedbackForm"
    >
      <div class="form-row">
        <label for="name">نام</label>
        <div class="form-group">
          <input
            type="text"
            formControlName="name"
            id="name"
          >
        </div>
        <ng-template [ngIf]="feedbackForm.get('name').dirty || feedbackForm.get('name').touched">
          <b class="validate-error" *ngIf="feedbackForm.get('name').hasError('required')">لطفا نام را وارد نمایید</b>
        </ng-template>
      </div>
      <div class="form-row">
        <label for="email">ایمیل</label>
        <div class="form-group">
          <input
            type="email"
            inputmode="email"
            formControlName="email"
            id="email"
            autocomplete="off"
          >
        </div>
        <ng-template [ngIf]="feedbackForm.get('email').dirty || feedbackForm.get('email').touched">
          <b class="validate-error" *ngIf="feedbackForm.get('email').hasError('required')">لطفا ایمیل را وارد نمایید</b>
          <b class="validate-error" *ngIf="feedbackForm.get('email').hasError('pattern')">ایمیل وارده شده اشتباه است</b>
        </ng-template>
      </div>
      <div class="form-row">
        <label for="phone">شماره تلفن/ موبایل</label>
        <div class="form-group">
          <input
            type="text"
            inputmode="phone"
            formControlName="phone"
            digitOnly
            id="phone"
            dir="ltr"
          >
        </div>
      </div>
      <div class="form-row">
        <label for="subject">موضوع</label>
        <div class="form-group">
          <input
            type="text"
            id="subject"
            [value]="activeSupportType ? activeSupportType?.title : null"
            (click)="openDialog()"
            readonly
          >
        </div>
        <ng-template [ngIf]="feedbackForm.get('supportType').dirty || feedbackForm.get('supportType').touched">
          <b class="validate-error" *ngIf="feedbackForm.get('email').hasError('required')">لطفا موضوع را انتخاب
                                                                                           نمایید</b>
        </ng-template>
      </div>
      <div class="form-row">
        <label for="description">شرح موضوع</label>
        <div class="form-group">
                <textarea
                  formControlName="description"
                  id="description"
                  rows="5"
                ></textarea>
        </div>
        <ng-template [ngIf]="feedbackForm.get('description').dirty || feedbackForm.get('description').touched">
          <b class="validate-error" *ngIf="feedbackForm.get('description').hasError('required')">لطفا توضیحات را وارد
                                                                                                 نمایید</b>
        </ng-template>
      </div>
      <navaar-button
        (onClick)="sendMessage()"
        [disabled]="!feedbackForm.valid"
        [type-button]="'submit'"
        [color-name]="'blue'"
        [class-name]="'btn-submit-feedback'"
        [isShowLoader]="isSubmitForm"
      >
        ارسال
      </navaar-button>
    </form>
  </section>
</navaar-container-scroll>

<ng-template [ngIf]="isShowDialog">
  <div
    class="overlay"
    (swipedown)="closeDialog()"
  ></div>
  <div
    (swipedown)="closeDialog()"
    [@slidePopup]="true"
    [formGroup]="feedbackForm"
    class="container-scroll-div"
    [style.max-height.px]="230"
  >
    <div class="wrapper-scroll-div">
      <section class="wrapper-item">
        <div class="container-dialog-description-type">
          <div class="wrapper-selects">
            <div style="padding-top: 16px;">
              <label>موضوع</label>
              <br/>
              <navaar-dropdown
                [items]="supportTypes"
                [(selected)]="activeSupportType"
                [showIcon]="true"
              ></navaar-dropdown>
            </div>
          </div>
          <div class="wrapper-btns">
            <div>
              <navaar-button
                [type-button]="'button'"
                [color-name]="'blue'"
                (onClick)="saveSubjectType()"
                [disabled]="!activeSupportType"
              >
                <span>انتخاب</span>
              </navaar-button>
            </div>
            <div>
              <navaar-button
                [type-button]="'button'"
                [color-name]="'green'"
                (onClick)="closeDialog()"
              >
                <span>انصراف</span>
              </navaar-button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</ng-template>
